package amazon.lastmile.inject

import app.nestbridge.feature.profile.ui.CreateUserProfileUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = CreateUserProfileUiFactory::class)
public interface AppNestbridgeFeatureProfileUiCreateUserProfileUiFactory {
  @Provides
  @IntoSet
  public fun provideCreateUserProfileUiFactoryFactoryMultibinding(createUserProfileUiFactory: CreateUserProfileUiFactory): Ui.Factory = createUserProfileUiFactory
}
